// 1. POPULATE POSTERS
// 2. LAUNCH MODAL
// 3. CLOSE MODAL
// 4. ACTIVATE CLEAR SEARCH ON INPUT
// 5. CLEAR SEARCH
// 6. APPLY FILTERS
// 7. CLEAR FILTERS
// 8. ENABLE APPLY FILTERS BUTTON
// 9. POSTER SEARCH
// 10. SORTBY
// 11. ORTBY DIRECTION
// 12. PAGINATION
// 13. LIST/CARD TOGGLE

$(function () {
  ("use strict");
  $.ajaxSetup({
    cache: false,
    data: {
      csrftoken: Cookies.get(cookie_pre + "csrfcookie"),
    },
  });

  let ctype = $("#congressPosterContainer").data("ctype");
  let preview = $("#congressPosterContainer").data("preview");

  //enable the clear button
  if ($("input.filter-checkbox:checked").length > 0) {
    $("#btnClearFilters").addClass("active");
  }

  //========================================================//
  // 1. POPULATE POSTERS
  //========================================================//
  if ($("#congressPosterContainer").length > 0) {
    populate_congress_posters();
  }

  //========================================================//
  // 2. LAUNCH MODAL
  //========================================================//
  $(".main_content").on("click", ".btnModal", function (event) {
    event.preventDefault();
    let popup = new Foundation.Reveal($("#infoModal"));
    popup.open();
  });

  //========================================================//
  // 3. CLOSE MODAL
  //========================================================//
  if ($(".close-reveal-modal").length > 0) {
    $(".close-reveal-modal").click(function () {
      $("body").removeClass("modal-open");
    });
  }

  //========================================================//
  // 4. ACTIVATE CLEAR SEARCH ON INPUT
  //========================================================//
  $(".main_content").on("input", "#search", function (event) {
    event.preventDefault();
    let value = $(this).val();
    if (value) {
      $(".clear-search").addClass("active");
    } else {
      $(".clear-search").removeClass("active");
    }
  });

  //========================================================//
  // 5. CLEAR SEARCH
  //========================================================//
  $(".main_content").on("click", ".clear-search", function (e) {
    e.preventDefault();

    if ($(this).hasClass("active")) {
      $("#search").val("");
      $(".clear-search").removeClass("active");
      populate_congress_posters();
    }
  });

  //========================================================//
  // 6. APPLY FILTERS
  //========================================================//
  $(".main_content").on("click", "#btnApplyFilters", function () {
    if (!$(this).hasClass("disabled")) {
      //reset the page to one
      $("#congressPosterContainer").attr("data-page", 1);
      //enable the clear button
      if ($("input.filter-checkbox:checked").length > 0) {
        $("#btnClearFilters").addClass("active");
      }

      //get the checked filters
      let filters = [];
      $(".filter-checkbox:checked").each(function () {
        let ftype = $(this).data("type");
        let val = $(this).val();
        let filter = {};

        filter.type = ftype;
        filter.val = val;

        filters.push(filter);
      });

      //apply filters
      apply_filters();
    }
  });

  //========================================================//
  // 7. ENABLE APPLY FILTERS BUTTON
  //========================================================//
  $(".main_content").on("change", "input.filter-checkbox", function () {
    //see if there are any checked filters
    if ($("input.filter-checkbox:checked").length > 0) {
      $("#btnApplyFilters").removeClass("disabled");
      $("#btnClearFilters").addClass("active");
    }
  });

  //========================================================//
  // 8. CLEAR FILTERS
  //========================================================//
  $(".main_content").on("click", ".clear-filter", function (e) {
    e.preventDefault();

    if ($(this).hasClass("active")) {
      $(".clear-filter").removeClass("active");
      $("input[type=checkbox].filter-checkbox").prop("checked", false);
      $("#btnApplyFilters").addClass("disabled");
      populate_congress_posters();
    }
  });

  //========================================================//
  // 9. POSTER SEARCH
  //========================================================//
  $(".main_content").on("submit", "#frmSearchPosters", function (e) {
    e.preventDefault();
    let search = $("#search").val();

    if (search.length > 0) {
      //add tracking for the search
      if (!preview) {
        _paq.push([
          "trackEvent",
          ctype,
          "SEARCH " + ctype.toUpperCase(),
          "SEARCH TERM: " + search,
        ]);
      }
      //reset the page to one
      $("#congressPosterContainer").attr("data-page", 1);
      $("#num-display").text(1);
      populate_congress_posters();
    }
  });

  //========================================================//
  // 10. SORTBY
  //========================================================//
  $(".banner-bar .ae-select-content").text(
    $(".dropdown-menu > li.selected").text()
  );

  $(".banner-bar .dropdown-menu > li").on("click", function () {
    $(".dropdown-menu").toggleClass("ae-hide");
    let order = $(this).data("field");
    let dir = $(this).data("dir") ? $(this).data("dir") : "";

    //get the selected value without any html
    let selected = $(this).text();

    if (dir) {
      $("#congressPosterContainer").attr("data-dir", dir);
      $("#btnSortDirection").attr("title", "Sort ascending");
    } else {
      $("#congressPosterContainer").attr("data-dir", "ASC");
      $("#btnSortDirection").attr("title", "Sort descending");
    }

    $("#congressPosterContainer").attr("data-order", order);

    $(".ae-select-content").text($(this).text());
    $(".dropdown-menu > li").removeClass("selected");
    $(this).addClass("selected");

    //add tracking for the sort
    if (!preview) {
      _paq.push([
        "trackEvent",
        ctype,
        "SORT " + ctype.toUpperCase(),
        selected + " " + dir,
      ]);
    }

    //populate posters
    populate_congress_posters();
  });

  $(".banner-bar .ae-dropdown").hover(
    function () {
      $(".dropdown-menu").removeClass("ae-hide");
    },
    function () {
      $(".dropdown-menu").addClass("ae-hide");
    }
  );

  $(".banner-bar .ae-dropdown, .dropdown-menu li ").on("click", function () {
    $(".dropdown-menu").toggleClass("ae-hide");
  });

  //========================================================//
  // 11. SORTBY DIRECTION
  //========================================================//
  $(".main_content").on("click", "#btnSortDirection", function (e) {
    e.preventDefault();

    let current = $("#congressPosterContainer").attr("data-dir");

    if (current == "ASC") {
      $("#congressPosterContainer").attr("data-dir", "DESC");
      $(this).attr("title", "Sort ascending");
    } else {
      $("#congressPosterContainer").attr("data-dir", "ASC");
      $(this).attr("title", "Sort Descending");
    }

    let selected = $(".dropdown-menu > li.selected").text();
    let newDir = $("#congressPosterContainer").attr("data-dir");

    //track the order change
    if (!preview) {
      _paq.push([
        "trackEvent",
        ctype,
        "SORT " + ctype.toUpperCase(),
        selected + " " + newDir,
      ]);
    }

    //populate posters
    populate_congress_posters();
  });

  //========================================================//
  // 12. PAGINATION
  //========================================================//
  $(".main_content").on("click", ".pagination-link", function (e) {
    e.preventDefault();

    if (!$(this).hasClass("disabled") && !$(this).parent().hasClass("active")) {
      $("#congressPosterContainer").attr("data-page", $(this).data("page"));
      //populate posters
      populate_congress_posters();
    }
  });

  //========================================================//
  // 13. LIST/CARD TOGGLE
  //========================================================//
  $(".main_content").on("click", ".switch-item", function (e) {
    e.preventDefault();

    if (!$(this).hasClass("active")) {
      let view = $(this).data("type");
      $(".switch-item").removeClass("active");
      $(this).addClass("active");
      $("#congressPosterContainer").attr("data-view", view);

      //track the view change
      if (!preview) {
        _paq.push([
          "trackEvent",
          ctype,
          "VIEW " + ctype.toUpperCase(),
          view.toUpperCase(),
        ]);
      }

      //populate posters
      populate_congress_posters();
    }
  });

  //========================================================//
  // 14. FILTER TOGGLE
  //========================================================//
  $(".main_content").on(
    "click",
    "#btnFilterToggle, #btnFilterToggleSmall",
    function (e) {
      let state = $(this).parent().hasClass("is-open") ? "CLOSE" : "OPEN";
      //track the filter open/close
      if (!preview) {
        _paq.push(["trackEvent", ctype, state + " FILTER", "Click"]);
      }
    }
  );

  //========================================================//
  // 15. CLOSE FILTER
  //========================================================//
  $(".main_content").on("click", "#btnCloseFilter", function (e) {
    //track the filter open/close
    if (!preview) {
      _paq.push(["trackEvent", ctype, "CLOSE FILTER", "Click"]);
    }
  });
});

//===========================//
//END DOCUMENT READY
//==========================//

//========================================================//
// 1. POPULATE CONGRESS POSTERS
//========================================================//
window.populate_congress_posters = function populate_congress_posters() {
  let search = $("#search").val();
  let congress_id = $("#congressPosterContainer").data("id");
  let view = $("#congressPosterContainer").attr("data-view");
  let type = $("#congressPosterContainer").attr("data-type");
  let order = $("#congressPosterContainer").attr("data-order");
  let dir = $("#congressPosterContainer").attr("data-dir");
  let preview = $("#congressPosterContainer").attr("data-preview");
  let page = $("#congressPosterContainer").attr("data-page");
  let per_page = $("#congressPosterContainer").attr("data-per-page");

  let filters = [];

  $(".filter-checkbox:checked").each(function () {
    let ftype = $(this).data("type");
    let base64_val = $(this).data("base64");
    let val = $(this).val();
    let filter = {};

    filter.type = ftype;
    filter.base64 = base64_val;
    filter.val = val;

    filters.push(filter);
  });
  let formData = new FormData($("#frmSearchPosters")[0]);
  if (search) {
    formData.append("search", search);
  }
  formData.append("congress_id", congress_id);
  formData.append("view", view);
  formData.append("type", type);
  formData.append("order", order);
  formData.append("dir", dir);
  formData.append("preview", preview);
  formData.append("page", page);
  formData.append("per_page", per_page);
  formData.append("filters", JSON.stringify(filters));

  $("#congressPosterContainer").html(
    '<div class="text-center preloader"><em class="fa fa-spinner fa-spin fa-5x fa-fw fa-pulse"></em><span class="sr-only">Loading...</span></div>'
  );
  setTimeout(function () {
    $.ajax({
      type: "POST",
      url: "/ajax/loadCongressPosters/",
      processData: false,
      contentType: false,
      data: formData,
      enctype: "multipart/form-data",
    }).done(function (data) {
      $("#congressPosterContainer").html(data);
      //show the filter tab
      $("#offCanvasLeftFilters").show();
      //update the total posters found
      $("#num-display").text($("#posterContainer").data("total-items"));
    });
  }, 10);
};

//========================================================//
// 2. APPLY FILTERS
//========================================================//
window.apply_filters = function apply_filters() {
  if ($(".filter-checkbox:checked").length > 0) {
    $(".clear-search").removeClass("active").addClass("active");
  } else if (!$("#search").val()) {
    $(".clear-search").removeClass("active");
  }

  let preview = $("#congressPosterContainer").data("preview") ?? false;
  let ctype = $("#congressPosterContainer").data("ctype");

  if (!preview) {
    let filters = {};

    //create a string of the selected filters for tracking grouped by type
    $(".filter-checkbox:checked").each(function () {
      let ftype = $(this).data("type");
      let val = $(this).val();

      filters[ftype] = filters[ftype] || "";

      if (val) {
        filters[ftype] += val + ", ";
      }
    });

    if (filters) {
      //track the filter apply
      _paq.push([
        "trackEvent",
        ctype,
        "APPLY FILTERS",
        JSON.stringify(filters),
      ]);
    }
  }

  populate_congress_posters();
};
